import { NavLink } from "react-router-dom";
import { Home, Wallet, CreditCard, Activity, User, Briefcase, Building2, MoreHorizontal, Layers } from "lucide-react";
import { useI18n } from "../lib/i18n";

export default function BottomNav({ variant = "consumer" }) {
    const { t } = useI18n();
    const CONSUMER_TABS = [
        { to: "/consumer", labelKey: "common.home", icon: Home, end: true },
        { to: "/consumer/credit", labelKey: "common.credit", icon: CreditCard },
        { to: "/consumer/wallet", labelKey: "common.wallet", icon: Wallet },
        { to: "/consumer/activity", labelKey: "common.activity", icon: Activity },
        { to: "/consumer/profile", labelKey: "common.profile", icon: User },
    ];
    const BUSINESS_TABS = [
        { to: "/business", labelKey: "common.home", icon: Home, end: true },
        { to: "/business/business", labelKey: "common.business", icon: Building2 },
        { to: "/business/finance", labelKey: "common.finance", icon: Wallet },
        { to: "/business/loans", labelKey: "common.loans", icon: CreditCard },
        { to: "/business/more", labelKey: "common.more", icon: MoreHorizontal },
    ];
    const tabs = variant === "business" ? BUSINESS_TABS : CONSUMER_TABS;
    const activeColor = variant === "business" ? "#0066FF" : "#7000FF";
    return (
        <nav
            className="absolute bottom-0 left-0 right-0 bg-white/90 backdrop-blur-xl border-t border-slate-200 px-1 pt-2 pb-safe z-50 flex justify-between items-center"
            data-testid={`bottom-nav-${variant}`}
        >
            {tabs.map((tb) => {
                const label = t(tb.labelKey);
                return (
                    <NavLink
                        key={tb.to}
                        to={tb.to}
                        end={tb.end}
                        data-testid={`nav-${variant}-${label.toLowerCase()}`}
                        className="flex-1 flex flex-col items-center gap-1 py-2 tap-feedback"
                    >
                        {({ isActive }) => (
                            <>
                                <tb.icon
                                    size={20}
                                    strokeWidth={isActive ? 2.5 : 2}
                                    style={{ color: isActive ? activeColor : "#94A3B8" }}
                                />
                                <span
                                    className="text-[10px] font-semibold"
                                    style={{ color: isActive ? activeColor : "#94A3B8" }}
                                >
                                    {label}
                                </span>
                            </>
                        )}
                    </NavLink>
                );
            })}
        </nav>
    );
}
